import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'

interface TabStubProps {
  label: string
  description: string
  next: string
}

/**
 * Placeholder for sibling tabs (Games / Live / Squadron) until their
 * dedicated screens land. Each one renders a labelled "under construction"
 * card pointing back to home so the user can't get stranded.
 */
export function TabStub({ label, description, next }: TabStubProps) {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-16 text-center">
      <p className="font-display text-[10px] tracking-[0.25em] text-fg-subtle uppercase">
        <span className="text-primary">//</span> {label}
      </p>
      <h2 className="font-display text-2xl font-semibold tracking-tight text-balance">
        {label} is coming next.
      </h2>
      <p className="text-sm text-fg-muted text-pretty">{description}</p>
      <Button asChild variant="primary" size="md">
        <Link to="/app">{next}</Link>
      </Button>
    </div>
  )
}
